import React from "react";
import SectionShell from "../layout/SectionShell";
import { aboutData } from "../../mock/portfolioData";

export function AboutSection() {
  return (
    <SectionShell id="about" title="About" kicker="Background">
      <div className="grid gap-10 md:grid-cols-[minmax(0,2fr)_minmax(0,1.3fr)]">
        <div className="space-y-4 text-sm leading-relaxed text-slate-300">
          <p className="text-slate-50">{aboutData.intro}</p>
          <p>{aboutData.story}</p>
          <p>{aboutData.uniqueness}</p>
        </div>
        <div className="space-y-4 rounded-2xl border border-slate-800 bg-slate-900/60 p-5 text-sm text-slate-100">
          <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.18em] text-cyan-300">
            What guides my work
          </h3>
          <ul className="space-y-2">
            {aboutData.values.map((value) => (
              <li
                key={value}
                className="rounded-xl border border-slate-800 bg-black/70 px-3 py-2 text-xs shadow-[0_0_16px_rgba(15,23,42,0.8)]"
              >
                {value}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </SectionShell>
  );
}

export default AboutSection;
